import { Link } from "react-router-dom";
import { SectionHeader, Reveal } from "./Reveal";
import FaqAccordion from "./FaqAccordion";
import { HOME_FAQ_ITEMS } from "../../content/faq";

export default function FaqSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-ivory border-t border-navy/10 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-14 lg:gap-20">
        <div>
          <SectionHeader overline="Good to Know" title={<>Frequently Asked <em className="italic font-medium">Questions</em></>} />
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-charcoal/80 max-w-md">
              Straight answers on how we work — manufacturing, exclusivity, minimum quantities, confidentiality and who owns the formula.
            </p>
            <Link
              to="/contact"
              data-testid="faq-contact-link"
              className="mt-6 inline-flex items-center text-sm font-semibold text-navy border-b border-navy/30 pb-1 hover:border-navy transition-colors duration-300"
            >
              Have another question? Ask us directly
            </Link>
          </Reveal>
        </div>
        <FaqAccordion items={HOME_FAQ_ITEMS} prefix="home-faq" />
      </div>
    </section>
  );
}
